import { ContainerBenefitResource, containerBenefitResource } from '@witkac/kartamiejska-resources';
import { ContainerBenefit } from '@witkac/kartamiejska-shared';

import { EntityModule } from '../entity.module';

/**
 * Moduł kontenerów partnera
 *
 * @export
 * @class ContainerBenefitsModule
 * @extends {EntityModule<ContainerBenefit,ContainerBenefitResource>}
 */
export class ContainerBenefitsModule extends EntityModule<ContainerBenefit, ContainerBenefitResource> {
  constructor() {
    super(containerBenefitResource);
  }
}

export default new ContainerBenefitsModule();
